<div class="visualizer-shell" [class.has-room]="urls.original" [class.room-filter-is-open]="roomFilterOpen">
  <header class="app-header" *ngIf="urls.original">
    <div class="mobile-statusbar" aria-hidden="true">
      <span>9:41</span>
      <span>▮▮▮ ))) ▰</span>
    </div>

    <div class="header-main">
      <button
        type="button"
        class="mobile-back-btn"
        *ngIf="urls.original"
        (click)="backToUpload()"
        aria-label="Kembali"
      >
        <mat-icon aria-hidden="true">arrow_back</mat-icon>
      </button>

      <div class="brand-block">
        <div class="logo-mark">
          <img [src]="companyPreviewImageUrl" alt="Logo company" (error)="onImageError($event)" />
        </div>
        <div class="brand-copy">
          <span class="brand-eyebrow">Studio Preview Interior</span>
          <h1>FRANTINCO AI VISUALIZER</h1>
          <p>Atur area ruang, pilih produk Frantinco, lalu lihat preview interior yang siap dipresentasikan.</p>
        </div>
      </div>

      <div class="desktop-header-actions">
        <button type="button" class="template-chip">
          <mat-icon class="chip-icon" aria-hidden="true">dashboard</mat-icon>
          <span>
            <strong>{{ activeRoomTitle }}</strong>
            <small>{{ activeRoomSummary }}</small>
          </span>
        </button>

        <label class="header-btn ghost">
          <input type="file" accept="image/png,image/jpeg,image/webp" (change)="onRoomUpload($event)" />
          <mat-icon aria-hidden="true">add_photo_alternate</mat-icon>
          Ganti Foto
        </label>

        <button type="button" class="header-btn primary" [disabled]="configuredSurfaceCount === 0" (click)="sendToEstimator()">
          <mat-icon aria-hidden="true">send</mat-icon>
          Kirim ke Estimator
        </button>

        <button type="button" class="header-btn primary" [disabled]="configuredSurfaceCount === 0" (click)="openQuoteModal()">
          <mat-icon aria-hidden="true">request_quote</mat-icon>
          Minta Penawaran
        </button>
      </div>

      <div class="mobile-header-actions" *ngIf="urls.original">
        <button type="button" class="mobile-icon-btn" (click)="toggleVisualizerOrientation()" aria-label="Ubah orientasi">
          <mat-icon aria-hidden="true">screen_rotation</mat-icon>
        </button>
        <label class="mobile-icon-btn camera-btn" aria-label="Ganti foto">
          <input type="file" accept="image/png,image/jpeg,image/webp" (change)="onRoomUpload($event)" />
          <mat-icon aria-hidden="true">add_a_photo</mat-icon>
        </label>
      </div>
    </div>

    <button type="button" class="mobile-template-chip" *ngIf="urls.original">
      <mat-icon class="chip-icon" aria-hidden="true">dashboard</mat-icon>
      <span>
        <strong>{{ activeRoomTitle }}</strong>
        <small>{{ activeRoomSummary }}</small>
      </span>
      <mat-icon aria-hidden="true">chevron_right</mat-icon>
    </button>
  </header>

  <frantinco-room-visualizer-landscape
    *ngIf="urls.original"
    [activeRoomTitle]="activeRoomTitle"
    [activeRoomSummary]="activeRoomSummary"
    [logoUrl]="companyPreviewImageUrl"
    [canOpenCatalog]="canOpenCatalog"
    [catalogOpen]="catalogOpen"
    [hasUsedProducts]="usedProductCount > 0"
    [hasActiveProduct]="!!activeProduct"
    [adjustmentOpen]="adjustmentOpen"
    [canSendToEstimator]="configuredSurfaceCount > 0"
    (back)="backToUpload()"
    (roomUpload)="onRoomUpload($event)"
    (toggleCatalog)="toggleMobileCatalog()"
    (toggleAdjustment)="toggleMobileAdjustment()"
    (requestQuote)="openQuoteModal()"
    (sendToEstimator)="sendToEstimator()"
    (toggleOrientation)="toggleVisualizerOrientation()"
  ></frantinco-room-visualizer-landscape>

  <ng-container *ngIf="!urls.original">
    <section class="upload-card">
      <div class="upload-copy">
        <div class="stacked-preview">
          <img src="assets/visualizer/rooms/office-1.jpg" alt="Preview ruangan" (error)="onImageError($event)" />
          <img
            class="company-preview-logo"
            [src]="companyPreviewImageUrl"
            alt="Preview company"
            (error)="onImageError($event)"
          />
        </div>

        <div>
          <span class="eyebrow">Mulai dari foto</span>
          <h2>Unggah foto ruangan atau pilih template.</h2>
          <p>Workspace baru tampil setelah foto dipilih. AI akan membuat hotspot area yang bisa diklik.</p>
        </div>
      </div>

      <label class="dropzone">
        <input type="file" accept="image/png,image/jpeg,image/webp" (change)="onRoomUpload($event)" />
        <mat-icon class="drop-icon" aria-hidden="true">cloud_upload</mat-icon>
        <strong>Unggah foto</strong>
        <small>PNG, JPG, atau WEBP</small>
      </label>
    </section>

    <section class="sample-section">
      <div class="section-heading template-heading">
        <div>
          <h2>Belum ada foto?</h2>
          <p>Pilih salah satu contoh ruangan.</p>
        </div>

        <button type="button" class="room-filter-btn" (click)="openRoomFilter()" aria-label="Saring template ruangan">
          <mat-icon class="filter-icon" aria-hidden="true">tune</mat-icon>
          Saring
        </button>
      </div>

      <div class="tabs template-category-tabs" aria-label="Kategori template ruangan">
        <button
          type="button"
          *ngFor="let group of roomGroups"
          [class.active]="selectedRoomGroup === group"
          (click)="selectRoomGroup(group)"
        >
          <span>{{ roomGroupLabel(group) }}</span>
        </button>
      </div>

      <div
        class="sample-grid"
        *ngIf="filteredRooms.length > 0; else emptyRooms"
        [style.--sample-columns]="sampleColumnCount"
      >
        <ng-container *ngIf="isMobileLandscapeViewport(); else defaultSampleColumns">
          <button
            type="button"
            class="sample-card"
            *ngFor="let room of filteredRooms; let roomIndex = index; trackBy: trackBySampleRoom"
            [style.--sample-height]="sampleCardHeight(roomIndex % sampleColumnCount, floorIndex(roomIndex / sampleColumnCount)) + 'px'"
            (click)="selectSampleRoom(room)"
          >
            <img [src]="safeImageUrl(room.imageUrl)" [alt]="room.title" (error)="onImageError($event)" />
            <span>{{ room.title }}</span>
          </button>
        </ng-container>

        <ng-template #defaultSampleColumns>
          <div class="sample-column" *ngFor="let column of sampleRoomColumns; let columnIndex = index; trackBy: trackBySampleColumn">
            <button
              type="button"
              class="sample-card"
              *ngFor="let room of column; let rowIndex = index; trackBy: trackBySampleRoom"
              [style.--sample-height]="sampleCardHeight(columnIndex, rowIndex) + 'px'"
              (click)="selectSampleRoom(room)"
            >
              <img [src]="safeImageUrl(room.imageUrl)" [alt]="room.title" (error)="onImageError($event)" />
              <span>{{ room.title }}</span>
            </button>
          </div>
        </ng-template>
      </div>

      <ng-template #emptyRooms>
        <p class="helper-text">Belum ada template untuk kategori {{ selectedRoomGroup }}.</p>
      </ng-template>
    </section>

    <div class="room-filter-overlay" *ngIf="roomFilterOpen" (click)="closeRoomFilter()">
      <div class="room-filter-panel" role="dialog" aria-modal="true" aria-labelledby="room-filter-title" (click)="$event.stopPropagation()">
        <div class="room-filter-header">
          <h2 id="room-filter-title">Pilih ruangan</h2>
          <button type="button" class="room-filter-close" (click)="closeRoomFilter()" aria-label="Tutup">x</button>
        </div>

        <div class="room-filter-list">
          <button
            type="button"
            class="room-filter-option"
            *ngFor="let group of roomGroups"
            [class.active]="pendingRoomGroup === group"
            (click)="choosePendingRoomGroup(group)"
          >
            <span>{{ group }}</span>
            <mat-icon class="room-filter-check" aria-hidden="true">check</mat-icon>
          </button>
        </div>

        <div class="room-filter-footer">
          <button type="button" class="room-filter-confirm" (click)="applyRoomFilter()">Konfirmasi</button>
        </div>
      </div>
    </div>
  </ng-container>

  <main class="workspace" *ngIf="urls.original">
    <section
      class="viewer-section"
      [class.catalog-is-open]="catalogOpen"
      [class.adjustment-is-open]="adjustmentOpen && !!activeProduct"
      [class.compare-tools-open]="mobileCompareControlsOpen"
    >
      <div class="detect-banner" *ngIf="isDetectingSurfaces || isPreparingSurface">
        <span class="spinner"></span>
        <span *ngIf="isDetectingSurfaces">AI sedang membaca hotspot ruangan...</span>
        <span *ngIf="!isDetectingSurfaces && isPreparingSurface">Menyiapkan mask dan slice area...</span>
      </div>

      <button
        type="button"
        class="viewer-download-btn"
        title="Download gambar"
        aria-label="Download gambar visualizer"
        (click)="downloadResult()"
      >
        <mat-icon aria-hidden="true">file_download</mat-icon>
      </button>

      <frantinco-three-room-canvas
        class="room-canvas"
        [imageUrl]="urls.original"
        [resultImageUrl]="urls.result"
        [previewTextureUrl]="selectedProductTextureUrl"
        [previewLayers]="previewLayers"
        [maskImageUrl]="activeSurfaceAssignment?.maskUrl || urls.mask"
        [sliceImageUrl]="activeSurfaceAssignment?.sliceUrl || urls.slice"
        [perspectivePoints]="settings.perspectivePoints"
        [pattern]="settings.pattern"
        [textureScale]="settings.textureScale"
        [textureRotation]="settings.rotationAngle"
        [previewFloorPatternRotationDeg]="settings.rotationAngle"
        [textureOffsetX]="settings.textureOffsetX"
        [textureOffsetY]="settings.textureOffsetY"
        [plankWidthM]="settings.plankWidthM"
        [plankLengthM]="settings.plankLengthM"
        [groutWidthM]="settings.groutWidthM"
        [groutEnabled]="settings.groutEnabled"
        [groutSizeMm]="settings.groutSizeMm"
        [groutColor]="settings.groutColor"
        [roomWidthM]="settings.roomWidthM"
        [roomDepthM]="settings.roomDepthM"
        [pixelsPerMeter]="settings.pixelsPerMeter"
        [mode]="viewerMode"
        [comparePosition]="comparePosition"
        (comparePositionChange)="comparePosition = $event"
        [resultOpacity]="1"
        [previewOpacity]="settings.opacity"
        [surfaceHotspots]="surfaceHotspots"
        [activeSurface]="activeSurfaceForCanvas"
        [activeInstanceId]="activeInstanceId"
        [isProcessing]="isCanvasProcessing"
        [loadingText]="canvasLoadingText"
        (surfaceHotspotClick)="selectSurfaceFromHotspot($event)"
      ></frantinco-three-room-canvas>

      <div
        class="room-product-card used-product-modal"
        *ngIf="usedProductsOpen && usedProductCount > 0"
        [class.dragging]="usedProductsDragging"
        [style.transform]="usedProductsTransform"
      >
        <div class="card-title-row drag-handle" (pointerdown)="startDrawerDrag('usedProducts', $event)">
          <strong>Produk di Ruangan</strong>
          <span>{{ usedProductCount }}</span>
        </div>

        <div class="used-product-list" *ngIf="assignedSurfaceList.length > 0; else emptyUsedProducts">
          <button
            type="button"
            class="room-product-row"
            *ngFor="let assignment of assignedSurfaceList"
            (click)="openUsedProduct(assignment)"
          >
            <span class="room-product-thumb-wrap">
              <img
                [src]="safeProductImageUrl(assignment.product.thumbnailUrl)"
                [alt]="assignment.product.name"
                (error)="onImageError($event)"
              />
              <small class="room-surface-badge">{{ usedAssignmentLabel(assignment) }}</small>
            </span>
            <span class="room-product-info">
              <b>{{ assignment.product.name }}</b>
              <em>{{ assignment.product.category }}</em>
            </span>
            <mat-icon aria-hidden="true">chevron_right</mat-icon>
          </button>
        </div>

        <ng-template #emptyUsedProducts>
          <p class="used-product-empty">Belum ada produk yang dipasang.</p>
        </ng-template>
      </div>

      <button
        *ngIf="usedProductCount > 0"
        type="button"
        class="used-products-fab"
        [class.active]="usedProductsOpen"
        (click)="toggleUsedProductsList()"
        [disabled]="usedProductCount === 0"
        aria-label="Produk terpakai"
      >
        <mat-icon aria-hidden="true">inventory_2</mat-icon>
        <b>{{ usedProductCount }}</b>
      </button>

      <button type="button" class="mobile-used-pill" *ngIf="usedProductCount > 0" (click)="toggleUsedProductsList()">
        Produk terpakai
        <mat-icon aria-hidden="true">chevron_right</mat-icon>
      </button>

      <div class="mobile-right-controls" *ngIf="activeSurfaceAssignment">
        <button
          type="button"
          class="mobile-round-btn compare-fab"
          [class.active]="mobileCompareControlsOpen"
          (click)="toggleMobileCompareControls()"
          aria-label="Mode bandingkan"
        >
          <mat-icon aria-hidden="true">compare</mat-icon>
        </button>
        <button
          type="button"
          class="mobile-round-btn download-fab"
          (click)="downloadResult()"
          aria-label="Download gambar"
        >
          <mat-icon aria-hidden="true">file_download</mat-icon>
        </button>
      </div>

      <div class="directional-control" *ngIf="activeSurfaceAssignment && viewerMode !== 'compare'">
        <button type="button" class="up" (click)="nudgeTextureOffset(0, -0.05)" aria-label="Geser atas"><mat-icon aria-hidden="true">keyboard_arrow_up</mat-icon></button>
        <button type="button" class="left" (click)="nudgeTextureOffset(-0.05, 0)" aria-label="Geser kiri"><mat-icon aria-hidden="true">keyboard_arrow_left</mat-icon></button>
        <button type="button" class="center" (click)="resetTextureOffset()" aria-label="Reset posisi pola"><mat-icon aria-hidden="true">center_focus_strong</mat-icon></button>
        <button type="button" class="right" (click)="nudgeTextureOffset(0.05, 0)" aria-label="Geser kanan"><mat-icon aria-hidden="true">keyboard_arrow_right</mat-icon></button>
        <button type="button" class="down" (click)="nudgeTextureOffset(0, 0.05)" aria-label="Geser bawah"><mat-icon aria-hidden="true">keyboard_arrow_down</mat-icon></button>
      </div>

      <div class="offset-rotation-control" *ngIf="activeSurfaceAssignment && viewerMode !== 'compare'">
        <button
          type="button"
          class="mobile-round-btn rotation-fab"
          (click)="updateTextureRotation((settings.rotationAngle || 0) + 90)"
          aria-label="Rotasi"
        >
          <mat-icon aria-hidden="true">rotate_right</mat-icon>
        </button>
        <div class="horizontal-rotation">
          <button type="button" (click)="updateTextureRotation((settings.rotationAngle || 0) - 5)" aria-label="Rotasi kiri">
            <mat-icon aria-hidden="true">keyboard_arrow_left</mat-icon>
          </button>
          <input
            type="range"
            min="-180"
            max="180"
            step="1"
            [ngModel]="settings.rotationAngle"
            (ngModelChange)="updateTextureRotation($event)"
            aria-label="Rotasi horizontal"
          />
          <button type="button" (click)="updateTextureRotation((settings.rotationAngle || 0) + 5)" aria-label="Rotasi kanan">
            <mat-icon aria-hidden="true">keyboard_arrow_right</mat-icon>
          </button>
        </div>
      </div>

      <div class="rotation-control" *ngIf="activeSurfaceAssignment && viewerMode !== 'compare'">
        <mat-icon class="rotation-icon" aria-hidden="true">rotate_right</mat-icon>
        <strong>Rotasi</strong>
        <input
          type="range"
          min="-180"
          max="180"
          step="1"
          [ngModel]="settings.rotationAngle"
          (ngModelChange)="updateTextureRotation($event)"
        />
        <label class="value-box value-input-wrap" aria-label="Nilai rotasi">
          <input
            type="number"
            min="-180"
            max="180"
            step="1"
            [value]="settings.rotationAngle || 0"
            (change)="updateTextureRotation($any($event.target).value)"
            (keydown.enter)="$any($event.target).blur()"
          />
          <span>°</span>
        </label>
      </div>

      <div class="bottom-compare-toolbar" *ngIf="activeSurfaceAssignment && mobileCompareControlsOpen">
        <div class="mode-tabs">
          <button type="button" [class.active]="viewerMode === 'original'" (click)="setViewerMode('original')">
            <mat-icon aria-hidden="true">image</mat-icon>
            Sebelum
          </button>
          <button type="button" [class.active]="viewerMode === 'preview'" (click)="setViewerMode('preview')">
            <mat-icon aria-hidden="true">auto_awesome</mat-icon>
            Visualisasi
          </button>
          <button type="button" [class.active]="viewerMode === 'compare'" (click)="setViewerMode('compare')">
            <mat-icon aria-hidden="true">compare</mat-icon>
            Bandingkan
          </button>
        </div>
      </div>

      <aside
        class="floating-drawer product-drawer"
        [class.open]="catalogOpen"
        [class.dragging]="catalogDrawerDragging"
        [class.catalog-filter-is-open]="catalogFilterOpen"
        [style.transform]="catalogDrawerTransform"
      >
        <div class="mobile-sheet-grabber"></div>

        <div class="drawer-header product-drawer-header drag-handle" (pointerdown)="startCatalogDrawerDrag($event)">
          <div>
            <span class="eyebrow">Katalog</span>
            <h2 class="catalog-heading-sr">{{ mobileCatalogTitle }}</h2>
            <nav class="mobile-catalog-breadcrumb" aria-label="Lokasi katalog">
              <button type="button" class="breadcrumb-home" (click)="backToCatalogCategories($event)" aria-label="Beranda katalog">
                <mat-icon aria-hidden="true">home</mat-icon>
              </button>
              <ng-container *ngIf="mobileCatalogStep === 'category'">
                <span class="breadcrumb-title">{{ mobileCatalogTitle }}</span>
              </ng-container>
              <ng-container *ngIf="mobileCatalogStep === 'series'">
                <span>/</span>
                <button type="button" class="breadcrumb-current" (click)="backToCatalogSeries($event)">
                  {{ mobileSelectedCategoryLabel }}
                </button>
                <span>/</span>
                <span class="breadcrumb-title">{{ mobileCatalogTitle }}</span>
              </ng-container>
              <ng-container *ngIf="mobileCatalogStep === 'product'">
                <span>/</span>
                <button type="button" class="breadcrumb-current" (click)="backToCatalogSeries($event)">
                  {{ mobileSelectedCategoryLabel }}
                </button>
                <span>/</span>
                <button type="button" class="breadcrumb-current" (click)="openCatalogSeries(selectedSeries, $event)">
                  {{ mobileSelectedSeriesLabel }}
                </button>
                <span>/</span>
                <span class="breadcrumb-title">{{ mobileCatalogTitle }}</span>
              </ng-container>
            </nav>
          </div>
          <button type="button" class="drawer-close" (pointerdown)="$event.stopPropagation()" (click)="catalogOpen = false" aria-label="Tutup katalog">
            <mat-icon aria-hidden="true">close</mat-icon>
          </button>
        </div>

        <ng-container *ngIf="catalogOpen">
          <div class="catalog-tools">
            <label class="catalog-search-pill">
              <mat-icon aria-hidden="true">search</mat-icon>
              <input
                type="search"
                name="catalog_search"
                [(ngModel)]="catalogSearchKeyword"
                placeholder="Cari produk..."
                autocomplete="off"
              />
            </label>
            <div class="catalog-filter-control" (pointerdown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
              <button
                type="button"
                class="catalog-filter-trigger"
                [class.active]="hasCatalogUsageFilter"
                [attr.aria-expanded]="catalogFilterOpen"
                aria-label="Filter produk"
                (click)="toggleCatalogFilter(); $event.stopPropagation()"
              >
                <mat-icon aria-hidden="true">tune</mat-icon>
                <span class="filter-active-dot" *ngIf="hasCatalogUsageFilter" aria-hidden="true"></span>
              </button>

              <div class="catalog-filter-panel" *ngIf="catalogFilterOpen" (pointerdown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
                <div class="catalog-filter-panel-header">
                  <strong>Penggunaan</strong>
                  <span>{{ catalogUsageFilterLabel }}</span>
                </div>

                <button
                  type="button"
                  class="catalog-filter-option"
                  [class.active]="catalogUsageFilter === 'all'"
                  (click)="selectCatalogUsageFilter('all'); $event.stopPropagation()"
                >
                  <span>Semua</span>
                  <small>{{ catalogUsageFilterCount('all') }}</small>
                </button>

                <button
                  type="button"
                  class="catalog-filter-option"
                  [class.active]="catalogUsageFilter === 'interior'"
                  (click)="selectCatalogUsageFilter('interior'); $event.stopPropagation()"
                >
                  <span>Interior</span>
                  <small>{{ catalogUsageFilterCount('interior') }}</small>
                </button>

                <button
                  type="button"
                  class="catalog-filter-option"
                  [class.active]="catalogUsageFilter === 'exterior'"
                  (click)="selectCatalogUsageFilter('exterior'); $event.stopPropagation()"
                >
                  <span>Exterior</span>
                  <small>{{ catalogUsageFilterCount('exterior') }}</small>
                </button>
              </div>
            </div>
          </div>

          <div class="mobile-catalog-content">
            <div class="mobile-category-row" *ngIf="mobileCatalogStep === 'category' && filteredCategoryCards.length > 0; else emptyMobileCategories">
              <button type="button" class="category-shortcut-card" aria-label="Kategori">
                <mat-icon aria-hidden="true">category</mat-icon>
                <span>Kategori</span>
              </button>
              <button
                type="button"
                class="mobile-category-card"
                *ngFor="let category of filteredCategoryCards; trackBy: trackByCatalogPhotoCard"
                [attr.data-desktop-catalog-category]="category.name"
                (click)="openCatalogCategory(category.name, $event)"
              >
                <img [src]="safeProductImageUrl(category.imageUrl)" [alt]="category.label" (error)="onImageError($event)" />
                <strong>{{ category.label }}</strong>
                <span>{{ category.count }} produk</span>
              </button>
            </div>

            <ng-template #emptyMobileCategories>
              <p class="catalog-empty" *ngIf="mobileCatalogStep === 'category'">Kategori tidak ditemukan.</p>
            </ng-template>

            <div class="mobile-category-row" *ngIf="mobileCatalogStep === 'series' && filteredSeriesCards.length > 0; else emptyMobileSeries">
              <button type="button" class="category-shortcut-card" (click)="backToCatalogCategories($event)">
                <mat-icon aria-hidden="true">arrow_back</mat-icon>
                <span>Kategori</span>
              </button>
              <button
                type="button"
                class="mobile-category-card"
                *ngFor="let series of filteredSeriesCards; trackBy: trackByCatalogPhotoCard"
                [attr.data-desktop-catalog-series]="series.name"
                (click)="openCatalogSeries(series.name, $event)"
              >
                <img [src]="safeProductImageUrl(series.imageUrl)" [alt]="series.label" (error)="onImageError($event)" />
                <strong>{{ series.label }}</strong>
                <span>{{ series.count }} produk</span>
              </button>
            </div>

            <ng-template #emptyMobileSeries>
              <p class="catalog-empty" *ngIf="mobileCatalogStep === 'series'">Seri tidak ditemukan.</p>
            </ng-template>

            <div class="mobile-product-row" *ngIf="mobileCatalogStep === 'product' && searchedProducts.length > 0; else emptyMobileProducts">
              <button type="button" class="category-shortcut-card" (click)="backToCatalogSeries($event)">
                <mat-icon aria-hidden="true">arrow_back</mat-icon>
                <span>Seri</span>
              </button>
              <button
                type="button"
                class="mobile-product-card"
                *ngFor="let product of searchedProducts; trackBy: trackByProductTexture"
                [class.active]="isAssignedProduct(product)"
                [class.selected]="selectedProduct?.sku === product.sku"
                (click)="selectProduct(product)"
              >
                <img [src]="safeProductImageUrl(product.thumbnailUrl)" [alt]="product.name" (error)="onImageError($event)" />
                <strong>{{ product.sku }}</strong>
                <span>{{ product.name }}</span>
              </button>
            </div>

            <ng-template #emptyMobileProducts>
              <p class="catalog-empty" *ngIf="mobileCatalogStep === 'product'">Produk tidak ditemukan.</p>
            </ng-template>
          </div>

          <div class="desktop-catalog-content">
            <div class="surface-switcher">
              <button
                type="button"
                *ngFor="let option of availableSurfaceOptions"
                [class.active]="settings.targetClass === option.value"
                [class.configured]="assignmentFor(option.value) !== null"
                (click)="setTargetSurface(option.value)"
              >
                <span>{{ option.label }}</span>
                <small>{{ assignmentSummaryFor(option.value) }}</small>
              </button>
            </div>

            <div class="surface-context">
              <span class="surface-active-dot" aria-hidden="true"></span>
              <strong>{{ selectedSurfaceLabel }}</strong>
              <span class="surface-info-divider" aria-hidden="true"></span>
              <small *ngIf="activeSurfaceAssignment as assignment; else emptyActiveSurface">
                {{ assignment.product.sku }} &bull; {{ assignment.product.name }}
              </small>
              <ng-template #emptyActiveSurface>
                <small>Belum ada produk untuk titik ini.</small>
              </ng-template>
            </div>

            <ng-container *ngIf="canShowCatalogProducts; else desktopSurfaceUnavailable">
              <div class="desktop-catalog-grid" *ngIf="mobileCatalogStep === 'category'">
                <button
                  type="button"
                  class="desktop-category-card"
                  *ngFor="let category of filteredCategoryCards; trackBy: trackByCatalogPhotoCard"
                  [attr.data-desktop-catalog-category]="category.name"
                  (click)="openCatalogCategory(category.name, $event)"
                >
                  <img [src]="safeProductImageUrl(category.imageUrl)" [alt]="category.label" (error)="onImageError($event)" />
                  <strong>{{ category.label }}</strong>
                  <span>{{ category.count }} produk</span>
                </button>
              </div>

              <div class="desktop-catalog-grid" *ngIf="mobileCatalogStep === 'series'">
                <button type="button" class="desktop-category-card back-card" (click)="backToCatalogCategories($event)">
                  <mat-icon aria-hidden="true">arrow_back</mat-icon>
                  Kategori
                </button>
                <button
                  type="button"
                  class="desktop-category-card"
                  *ngFor="let series of filteredSeriesCards; trackBy: trackByCatalogPhotoCard"
                  [attr.data-desktop-catalog-series]="series.name"
                  (click)="openCatalogSeries(series.name, $event)"
                >
                  <img [src]="safeProductImageUrl(series.imageUrl)" [alt]="series.label" (error)="onImageError($event)" />
                  <strong>{{ series.label }}</strong>
                  <span>{{ series.count }} produk</span>
                </button>
              </div>

              <div class="product-grid" *ngIf="mobileCatalogStep === 'product'">
                <button type="button" class="product-card back-card" (click)="backToCatalogSeries($event)">
                  <mat-icon aria-hidden="true">arrow_back</mat-icon>
                  Seri
                </button>
                <button
                  type="button"
                  class="product-card"
                  *ngFor="let product of searchedProducts; trackBy: trackByProductTexture"
                  [class.active]="isAssignedProduct(product)"
                  [class.selected]="selectedProduct?.sku === product.sku"
                  (click)="selectProduct(product)"
                >
                  <img [src]="safeProductImageUrl(product.thumbnailUrl)" [alt]="product.name" (error)="onImageError($event)" />
                  <strong>{{ product.sku }}</strong>
                  <span>{{ product.name }}</span>
                </button>
              </div>
            </ng-container>

            <ng-template #desktopSurfaceUnavailable>
              <div class="catalog-empty desktop-catalog-unavailable">
                <strong>{{ selectedSurfaceLabel }} tidak tersedia di foto ini.</strong>
                <span>Pilih titik area lain yang terdeteksi AI.</span>
              </div>
            </ng-template>
          </div>
        </ng-container>
      </aside>

      <aside
        class="floating-drawer adjust-drawer desktop-adjust-drawer"
        [class.open]="adjustmentOpen && activeProduct"
        [class.dragging]="adjustDrawerDragging"
        [style.transform]="adjustDrawerTransform"
      >
        <div class="mobile-sheet-grabber"></div>

        <ng-container *ngIf="activeProduct as product">
          <div class="drawer-header desktop-drawer-header drag-handle" (pointerdown)="startDrawerDrag('adjust', $event)">
            <div>
              <span class="eyebrow">PENGATURAN</span>
            </div>
            <button type="button" class="drawer-close" (pointerdown)="$event.stopPropagation()" (click)="adjustmentOpen = false" aria-label="Tutup pengaturan">
              <mat-icon aria-hidden="true">close</mat-icon>
            </button>
          </div>

          <div class="desktop-adjust-content">
            <div class="selected-product-card">
              <div class="product-setting-content">
                <div class="product-setting-media">
                  <img
                    class="product-setting-image"
                    [src]="safeProductImageUrl(product.thumbnailUrl)"
                    [alt]="product.name"
                    (error)="onImageError($event)"
                  />
                  <span class="surface-badge">
                    <span class="surface-dot"></span>
                    {{ selectedSurfaceLabel }}
                  </span>
                </div>

                <div class="product-setting-info">
                  <div class="product-title-row">
                    <h3>{{ product.name }}</h3>
                  </div>
                  <small class="product-category">{{ product.category }}</small>
                  <p class="product-description">
                    {{
                      product.description ||
                      (($any(product).width || (($any(product).plankWidthM || settings.plankWidthM || 0) * 1000)) | number:'1.0-0') +
                      ' x ' +
                      (($any(product).height || (($any(product).plankLengthM || settings.plankLengthM || 0) * 1000)) | number:'1.0-0') +
                      ' mm'
                    }}
                  </p>
                </div>
              </div>

              <div class="product-action-row">
                <button type="button" class="outline-orange-button" (click)="openCatalogFromAdjustment()">
                  <mat-icon aria-hidden="true">swap_horiz</mat-icon>
                  Ganti produk
                </button>
                <button type="button" class="outline-orange-button" (click)="randomizeLayout()">
                  <mat-icon aria-hidden="true">shuffle</mat-icon>
                  Acak tata letak
                </button>
              </div>
            </div>

            <section class="adjust-section pattern-selector-section" [class.open]="patternDropdownOpen">
              <span class="pattern-selector-label">Pola</span>
              <div class="pattern-dropdown" [class.open]="patternDropdownOpen" (pointerdown)="$event.stopPropagation()">
                <button
                  type="button"
                  class="pattern-select-card"
                  [class.active]="patternDropdownOpen"
                  (pointerdown)="$event.stopPropagation()"
                  (click)="togglePatternDropdown($event)"
                  aria-haspopup="listbox"
                  [attr.aria-expanded]="patternDropdownOpen"
                >
                  <span class="pattern-preview" [attr.data-pattern]="selectedPatternOption.value">
                    <img [src]="selectedPatternOption.previewUrl" [alt]="selectedPatternOption.label" />
                  </span>
                  <span class="pattern-name">{{ selectedPatternOption.label }}</span>
                  <mat-icon class="pattern-chevron" aria-hidden="true">expand_more</mat-icon>
                </button>

                <div
                  class="pattern-option-list"
                  *ngIf="patternDropdownOpen"
                  role="listbox"
                  (pointerdown)="$event.stopPropagation()"
                  (click)="$event.stopPropagation()"
                >
                  <button
                    type="button"
                    class="pattern-option"
                    *ngFor="let option of activePatternOptions"
                    [class.selected]="option.value === selectedPatternOption.value"
                    (pointerdown)="selectPatternOption(option.value, $event)"
                    (click)="selectPatternOption(option.value, $event)"
                    role="option"
                    [attr.aria-selected]="option.value === selectedPatternOption.value"
                  >
                    <span class="pattern-preview" [attr.data-pattern]="option.value">
                      <img [src]="option.previewUrl" [alt]="option.label" />
                    </span>
                    <span class="pattern-name">{{ option.label }}</span>
                    <mat-icon class="pattern-check" *ngIf="option.value === selectedPatternOption.value" aria-hidden="true">check</mat-icon>
                  </button>
                </div>
              </div>
            </section>

            <section class="adjust-section grout-section">
              <div class="grout-control-grid">
                <div class="grout-control-field">
                  <span class="grout-control-label">Nat</span>
                  <label class="grout-toggle">
                    <input
                      type="checkbox"
                      [ngModel]="settings.groutEnabled"
                      (ngModelChange)="updateGroutEnabled($event)"
                    />
                    <span>{{ settings.groutEnabled ? 'Aktif' : 'Mati' }}</span>
                  </label>
                </div>

                <label class="grout-control-field" for="grout-size-select">
                  <span class="grout-control-label">Ukuran</span>
                  <select
                    id="grout-size-select"
                    [ngModel]="currentGroutSizeMm"
                    (ngModelChange)="updateGroutWidth($event)"
                    aria-label="Ukuran nat"
                  >
                    <option *ngFor="let size of groutSizeOptions" [ngValue]="size">
                      {{ size }} mm
                    </option>
                  </select>
                </label>

                <div class="grout-control-field">
                  <span class="grout-control-label">Warna</span>
                  <label class="grout-color-chip" [style.background]="currentGroutColor">
                    <input
                      type="color"
                      class="grout-color-input"
                      [ngModel]="currentGroutColor"
                      (ngModelChange)="updateGroutColor($event)"
                      aria-label="Warna nat"
                    />
                  </label>
                </div>
              </div>
            </section>

            <section class="adjust-actions">
              <button type="button" class="wide-action-btn subtle" (click)="resetPatternControls()">Reset pola</button>
              <button type="button" class="wide-action-btn danger" [disabled]="!activeSurfaceAssignment" (click)="removeSurfaceAssignment(); adjustmentOpen = false">
                Kosongkan produk aktif
              </button>
            </section>
          </div>
        </ng-container>
      </aside>

      <aside
        class="floating-drawer adjust-drawer mobile-adjust-drawer"
        [class.open]="adjustmentOpen && activeProduct"
      >
        <div class="mobile-sheet-grabber"></div>

        <ng-container *ngIf="activeProduct as product">
          <div class="mobile-adjust-content">
            <div class="mobile-adjust-header">
              <button type="button" class="mobile-adjust-back" *ngIf="mobileAdjustMode !== 'main'" (click)="mobileAdjustMode = 'main'" aria-label="Kembali">
                <mat-icon aria-hidden="true">arrow_back</mat-icon>
              </button>
              <strong>
                <span class="portrait-adjust-title">{{ mobileAdjustTitle }}</span>
                <span class="landscape-adjust-title">{{ landscapeAdjustTitle }}</span>
              </strong>
              <button type="button" class="mobile-adjust-icon" (click)="adjustmentOpen = false; mobileAdjustMode = 'main'" aria-label="Tutup">
                <mat-icon aria-hidden="true">close</mat-icon>
              </button>
            </div>

            <div class="mobile-adjust-main" *ngIf="mobileAdjustMode === 'main'">
              <button type="button" class="mobile-tool-card" (click)="openMobileAdjustMode('pattern')"><mat-icon aria-hidden="true">grid_view</mat-icon><b>Pola</b></button>
              <button type="button" class="mobile-tool-card" (click)="openMobileAdjustMode('offset')"><mat-icon aria-hidden="true">open_with</mat-icon><b>Pindah</b></button>
              <button type="button" class="mobile-tool-card" (click)="openMobileAdjustMode('rotation')"><mat-icon aria-hidden="true">rotate_right</mat-icon><b>Rotasi</b></button>
              <button type="button" class="mobile-tool-card" (click)="openMobileAdjustMode('grout')"><mat-icon aria-hidden="true">grain</mat-icon><b>Nat</b></button>
              <button type="button" class="mobile-tool-card mobile-compare-tool-card" [disabled]="!activeSurfaceAssignment" (click)="openMobileAdjustMode('compare')"><mat-icon aria-hidden="true">compare</mat-icon><b>Komparasi</b></button>
              <button type="button" class="mobile-tool-card mobile-products-menu-card" (click)="openMobileAdjustMode('products')">
                <span class="mobile-tool-badge" *ngIf="usedProductCount > 0">{{ usedProductCount }}</span>
                <mat-icon aria-hidden="true">inventory_2</mat-icon>
                <b>Produk</b>
              </button>
              <button type="button" class="mobile-tool-card" (click)="randomizeLayout()"><mat-icon aria-hidden="true">shuffle</mat-icon><b>Acak</b></button>
            </div>

            <div class="mobile-adjust-subpanel mobile-products-subpanel" *ngIf="mobileAdjustMode === 'products'">
              <div class="mobile-used-products-strip" *ngIf="assignedSurfaceList.length > 0; else emptyMobileUsedProducts" aria-label="Produk di ruangan">
                <button
                  type="button"
                  class="mobile-used-product-card"
                  *ngFor="let assignment of assignedSurfaceList"
                  [class.active]="isUsedAssignmentActive(assignment)"
                  (click)="openUsedProduct(assignment); mobileAdjustMode = 'products'"
                >
                  <span class="mobile-used-product-thumb">
                    <img
                      [src]="safeProductImageUrl(assignment.product.thumbnailUrl)"
                      [alt]="assignment.product.name"
                      (error)="onImageError($event)"
                    />
                    <small>{{ usedAssignmentLabel(assignment) }}</small>
                  </span>
                  <span class="mobile-used-product-copy">
                    <strong>{{ assignment.product.name }}</strong>
                  </span>
                </button>
              </div>
              <ng-template #emptyMobileUsedProducts>
                <p class="used-product-empty">Belum ada produk yang dipasang.</p>
              </ng-template>
            </div>

            <div class="mobile-adjust-subpanel" *ngIf="mobileAdjustMode === 'pattern'">
              <button
                type="button"
                class="mobile-pattern-card"
                *ngFor="let option of activePatternOptions"
                [class.active]="selectedPatternOption.value === option.value"
                (pointerdown)="selectPatternOption(option.value, $event)"
                (click)="selectPatternOption(option.value, $event)"
              >
                <span class="pattern-preview" [attr.data-pattern]="option.value">
                  <img [src]="option.previewUrl" [alt]="option.label" />
                </span>
                <strong>{{ option.label }}</strong>
              </button>
            </div>

            <div class="mobile-adjust-subpanel mobile-offset-subpanel" *ngIf="mobileAdjustMode === 'offset'">
              <div class="mobile-offset-controls">
                <label class="mobile-offset-field">
                  <div class="mobile-offset-slider-row">
                    <span>Offset X</span>
                    <button type="button" (click)="nudgeTextureOffset(-0.05, 0)" aria-label="Kurangi offset X">
                      <mat-icon aria-hidden="true">keyboard_arrow_left</mat-icon>
                    </button>
                    <input
                      type="range"
                      min="-1"
                      max="1"
                      step="0.01"
                      [ngModel]="settings.textureOffsetX || 0"
                      (ngModelChange)="updateTextureOffsetX($event)"
                      aria-label="Offset X"
                    />
                    <button type="button" (click)="nudgeTextureOffset(0.05, 0)" aria-label="Tambah offset X">
                      <mat-icon aria-hidden="true">keyboard_arrow_right</mat-icon>
                    </button>
                    <b>{{ (settings.textureOffsetX || 0) | number:'1.2-2' }}</b>
                  </div>
                </label>

                <label class="mobile-offset-field">
                  <div class="mobile-offset-slider-row">
                    <span>Offset Y</span>
                    <button type="button" (click)="nudgeTextureOffset(0, -0.05)" aria-label="Kurangi offset Y">
                      <mat-icon aria-hidden="true">keyboard_arrow_up</mat-icon>
                    </button>
                    <input
                      type="range"
                      min="-1"
                      max="1"
                      step="0.01"
                      [ngModel]="settings.textureOffsetY || 0"
                      (ngModelChange)="updateTextureOffsetY($event)"
                      aria-label="Offset Y"
                    />
                    <button type="button" (click)="nudgeTextureOffset(0, 0.05)" aria-label="Tambah offset Y">
                      <mat-icon aria-hidden="true">keyboard_arrow_down</mat-icon>
                    </button>
                    <b>{{ (settings.textureOffsetY || 0) | number:'1.2-2' }}</b>
                  </div>
                </label>

                <button type="button" class="mobile-offset-reset" (click)="resetTextureOffset()">
                  <mat-icon aria-hidden="true">center_focus_strong</mat-icon>
                  Reset posisi
                </button>
              </div>
            </div>

            <div class="mobile-adjust-subpanel mobile-rotation-subpanel" *ngIf="mobileAdjustMode === 'rotation'">
              <label class="mobile-rotation-field">
                <span>Rotasi</span>
                <b>{{ settings.rotationAngle || 0 }}°</b>
                <input
                  type="range"
                  min="-180"
                  max="180"
                  step="1"
                  [ngModel]="settings.rotationAngle"
                  (ngModelChange)="updateTextureRotation($event)"
                  aria-label="Rotasi pola"
                />
                <label class="value-box value-input-wrap" aria-label="Nilai rotasi">
                  <input
                    type="number"
                    min="-180"
                    max="180"
                    step="1"
                    [value]="settings.rotationAngle || 0"
                    (change)="updateTextureRotation($any($event.target).value)"
                    (keydown.enter)="$any($event.target).blur()"
                  />
                  <span>°</span>
                </label>
              </label>
            </div>

            <div class="mobile-adjust-subpanel mobile-compare-subpanel" *ngIf="mobileAdjustMode === 'compare'">
              <button type="button" [class.active]="viewerMode === 'original'" (click)="setViewerMode('original')">
                <mat-icon aria-hidden="true">image</mat-icon>
                <b>Sebelum</b>
              </button>
              <button type="button" [class.active]="viewerMode === 'preview'" (click)="setViewerMode('preview')">
                <mat-icon aria-hidden="true">auto_awesome</mat-icon>
                <b>Visualisasi</b>
              </button>
              <button type="button" [class.active]="viewerMode === 'compare'" (click)="comparePosition = 0.5; setViewerMode('compare')">
                <mat-icon aria-hidden="true">compare</mat-icon>
                <b>Bandingkan</b>
              </button>
            </div>

            <div class="mobile-adjust-subpanel" *ngIf="mobileAdjustMode === 'grout'">
              <div class="grout-control-grid mobile-grout-grid">
                <div class="grout-control-field">
                  <span class="grout-control-label">Nat</span>
                  <label class="grout-toggle">
                    <input
                      type="checkbox"
                      [ngModel]="settings.groutEnabled"
                      (ngModelChange)="updateGroutEnabled($event)"
                    />
                    <span>{{ settings.groutEnabled ? 'Aktif' : 'Mati' }}</span>
                  </label>
                </div>

                <label class="grout-control-field">
                  <span class="grout-control-label">Ukuran</span>
                  <select
                    class="mobile-grout-size"
                    [ngModel]="currentGroutSizeMm"
                    (ngModelChange)="updateGroutWidth($event)"
                    aria-label="Ukuran nat"
                  >
                    <option *ngFor="let size of groutSizeOptions" [ngValue]="size">
                      {{ size }} mm
                    </option>
                  </select>
                </label>

                <div class="grout-control-field">
                  <span class="grout-control-label">Warna</span>
                  <label class="grout-color-chip" [style.background]="currentGroutColor">
                    <input
                      type="color"
                      class="grout-color-input"
                      [ngModel]="currentGroutColor"
                      (ngModelChange)="updateGroutColor($event)"
                      aria-label="Warna nat"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </aside>

      <div class="floating-dock">
        <button type="button" class="dock-btn" [class.active]="catalogOpen" [disabled]="!canOpenCatalog" (click)="toggleCatalog()">
          <mat-icon aria-hidden="true">inventory_2</mat-icon>
          <b>Produk</b>
        </button>
        <button type="button" class="dock-btn" *ngIf="activeProduct" [class.active]="adjustmentOpen" (click)="adjustmentOpen = !adjustmentOpen; catalogOpen = false">
          <mat-icon aria-hidden="true">tune</mat-icon>
          <b>Atur</b>
        </button>
      </div>

      <nav class="mobile-bottom-bar" aria-label="Navigasi visualizer mobile">
        <button type="button" class="mobile-bottom-tab" [class.active]="catalogOpen" [disabled]="!canOpenCatalog" (click)="toggleMobileCatalog()">
          <mat-icon aria-hidden="true">inventory_2</mat-icon>
          <strong>Katalog</strong>
        </button>
        <button type="button" class="mobile-bottom-tab" [class.active]="adjustmentOpen" [disabled]="!activeProduct" (click)="toggleMobileAdjustment()">
          <mat-icon aria-hidden="true">tune</mat-icon>
          <strong>Atur</strong>
        </button>
        <button type="button" class="mobile-bottom-tab" [disabled]="configuredSurfaceCount === 0" (click)="openQuoteModal()">
          <mat-icon aria-hidden="true">request_quote</mat-icon>
          <strong>Permintaan Penawaran</strong>
        </button>
        <button type="button" class="mobile-bottom-tab" [disabled]="configuredSurfaceCount === 0" (click)="sendToEstimator()">
          <mat-icon aria-hidden="true">send</mat-icon>
          <strong>Kirim ke Estimator</strong>
        </button>
      </nav>

      <div class="status-row floating-status" *ngIf="errorMessage || successMessage">
        <div class="alert error" *ngIf="errorMessage">{{ errorMessage }}</div>
        <div class="alert success" *ngIf="successMessage">{{ successMessage }}</div>
      </div>
    </section>
  </main>

  <div class="quote-modal-overlay" *ngIf="quoteModalState !== 'closed'" (click)="closeQuoteModal()">
    <section
      class="quote-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="quote-modal-title"
      (click)="$event.stopPropagation()"
    >
      <ng-container *ngIf="quoteModalState === 'whatsapp_form'">
        <div class="quote-form-header">
          <div>
            <h2 id="quote-modal-title">Kirim Permintaan</h2>
          </div>
          <button type="button" class="quote-close-btn" (click)="closeQuoteModal()" aria-label="Tutup">
            <mat-icon aria-hidden="true">close</mat-icon>
          </button>
        </div>

        <form class="quote-form" (ngSubmit)="submitQuoteWhatsapp()">
          <ng-container *ngTemplateOutlet="quoteProductsTemplate"></ng-container>

          <label class="quote-field">
            <span>Catatan opsional</span>
            <textarea name="quote_whatsapp_note" [(ngModel)]="quoteNote" rows="3" placeholder="Tolong info harga dan stok."></textarea>
          </label>

          <p class="quote-error" *ngIf="quoteError">{{ quoteError }}</p>

          <button type="submit" class="quote-submit-btn whatsapp" [disabled]="quoteSubmitting">
            <svg class="quote-whatsapp-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M12.04 3.5a8.43 8.43 0 0 0-7.13 12.93l-.9 3.3 3.39-.89a8.42 8.42 0 0 0 4.64 1.39h.01a8.37 8.37 0 0 0 5.98-2.48 8.42 8.42 0 0 0-5.99-14.25Zm4.95 12.48a6.93 6.93 0 0 1-4.94 2.04h-.01a6.9 6.9 0 0 1-3.52-.96l-.24-.14-2.01.53.54-1.96-.16-.25a6.92 6.92 0 1 1 10.34.74Zm-1.22-1.94c-.2-.1-1.18-.58-1.36-.65-.18-.07-.32-.1-.45.1-.13.2-.51.65-.62.78-.11.13-.23.15-.42.05-.2-.1-.83-.31-1.58-.98a5.93 5.93 0 0 1-1.09-1.36c-.11-.2-.01-.3.09-.4.09-.09.2-.23.3-.34.1-.12.13-.2.2-.33.06-.13.03-.25-.02-.35-.05-.1-.45-1.08-.61-1.48-.16-.39-.33-.33-.45-.34h-.38c-.13 0-.35.05-.53.25-.18.2-.7.68-.7 1.66s.72 1.93.82 2.06c.1.13 1.42 2.17 3.44 3.04.48.21.86.33 1.15.42.48.15.92.13 1.27.08.39-.06 1.18-.48 1.35-.95.17-.47.17-.87.12-.95-.05-.08-.18-.13-.38-.23Z" />
            </svg>
            {{ quoteSubmitting ? 'Membuat...' : 'Buat Pesan WhatsApp' }}
          </button>
        </form>
      </ng-container>

      <ng-template #quoteProductsTemplate>
        <section class="quote-products">
          <div class="quote-products-title">
            <span>Produk yang Dipilih</span>
            <small>{{ quoteProducts.length }} produk</small>
          </div>

          <div class="quote-product-row" *ngFor="let item of quoteProducts; let index = index; trackBy: trackByQuoteProduct">
            <div class="quote-product-main">
              <strong>{{ item.surface }} - {{ item.productCode }}</strong>
              <span>{{ item.productName || 'Nama produk belum tersedia' }}</span>
              <small>{{ item.pattern }}{{ item.area ? ' · ' + item.area + ' m2' : '' }}</small>
            </div>

            <label class="quote-box-field">
              <span>Box</span>
              <input
                type="number"
                min="1"
                step="1"
                [name]="'quote_box_' + index"
                [(ngModel)]="item.boxQty"
                required
              />
            </label>
          </div>
        </section>
      </ng-template>
    </section>
  </div>
</div>
